export const TEST_PURPOSES = [
  'None Selected',
  'Initial Test',
  'Follow Up',
  'Post Mitigation',
  'Real Estate',
  'Duplicate Test',
];

export const TEST_TYPES = {
  test: 'Test',
  qc: 'QC Test',
  dinamicQc: 'QCTest',
};

export const QC_DEVICE_TYPE_OPTIONS = [
  {
    value: 'ActivatedCharcoal',
    label: 'Activated Charcoal',
  },
  {
    value: 'AlphaTrack',
    label: 'Alpha Track',
  },
  {
    value: 'ContinuousRadonMonitor',
    label: 'Continuous Radon Monitor',
  },
  {
    value: 'ElectretIonChamber',
    label: 'Electret Ion Chamber',
  },
  {
    value: 'LiquidScintillation',
    label: 'Liquid Scintillation',
  },
];

export const getDinamycTestName = (name) => {
  switch (name) {
    case 'serialNumber':
      return 'QcSerialNumber';
    case 'seviceType':
      return 'QcSeviceType';
    case 'deviceModel':
      return 'QcDeviceModel';
    case 'unitOfMeasure':
      return 'QcUnitOfMeasure';
    case 'averageRadon':
      return 'QcAverageRadon';
    case 'averageTemperature':
      return 'QcAverageTemperature';
    case 'averageHumidity':
      return 'QcAverageHumidity';
    case 'averagePressure':
      return 'QcAveragePressure';
    case 'deviceType':
      return 'QcDeviceType';
    default:
      return null;
  }
};



// WEBPACK FOOTER //
// src/constants/test.js